import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Notifications from 'vue-notification'
import vuetify from './plugins/vuetify'
import i18n from './i18n'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import ToggleButton from 'vue-js-toggle-button'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import VueObserveVisibility from 'vue-observe-visibility'
import VueLottiePlayer from 'vue-lottie-player'
// Import Bootstrap and BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import PrimeVue from 'primevue/config'
import Vuelidate from 'vuelidate'
import VueCarousel from 'vue-carousel'

Vue.use(VueCarousel)
Vue.use(Vuelidate)
Vue.use(VueLottiePlayer)
Vue.use(PrimeVue)
Vue.use(VueObserveVisibility)
// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
Vue.use(ToggleButton)
// import VueSocialSharing from 'vue-social-sharing'
// Vue.use(VueSocialSharing)
Vue.config.productionTip = false
Vue.prototype.$lang = ''
Vue.use(Notifications)
new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
Vue.directive('click-outside', {
  bind (el, binding, vnode) {
    el.clickOutsideEvent = (event) => {
      if (!(el === event.target || el.contains(event.target))) {
        vnode.context[binding.expression](event)
      }
    }
    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unbind (el) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
  }
})
